import axios from "../config/axios.v2";
import { BLOG_CATEGORY_URL, blogCategoryByIdUrl } from "./blog-category.url.service";

const unwrap = (res) => res.data?.data ?? res.data;
const unwrapList = (res) => ({
  data: res.data?.datas || res.data,
  pagination: res.data?.pagination ?? {}
});

const handleError = (err) => {
  console.log("blogCategoryService err::", err);
  throw err;
};

const BlogCategoryService = {
  getAll: (params) =>
    axios.get(BLOG_CATEGORY_URL, { params }).then(unwrapList).catch(handleError),
  getById: (id) => axios.get(blogCategoryByIdUrl(id)).then(unwrap).catch(handleError),
  create: (payload) => axios.post(BLOG_CATEGORY_URL, payload).then(unwrap).catch(handleError),
  update: (id, payload) =>
    axios.patch(blogCategoryByIdUrl(id), payload).then(unwrap).catch(handleError),
  remove: (id) => axios.delete(blogCategoryByIdUrl(id)).then(unwrap).catch(handleError)
};

export default BlogCategoryService;
